'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = undefined;

var _lib = require('./lib');

var _style = require('./style');

let Col = exports.Col = class Col {

  constructor(_ref) {
    let min = _ref.min,
        max = _ref.max;
    var _ref$hidden = _ref.hidden;
    let hidden = _ref$hidden === undefined ? false : _ref$hidden;
    var _ref$collapsed = _ref.collapsed;
    let collapsed = _ref$collapsed === undefined ? false : _ref$collapsed;
    var _ref$width = _ref.width;
    let width = _ref$width === undefined ? 0 : _ref$width;
    this.outlineLevel = 0;
    this.numFmt = '';

    this.min = min;
    this.max = max;
    this.hidden = hidden;
    this.collapsed = collapsed;
    this.width = width;
    this.style = new _style.Style();
  }
  setType(cellType) {
    this.numFmt = _lib.NumFmt[cellType];
  }
};